import React from "react";
import { Form, Input, Row, Col, Button, message, Alert } from "antd";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import { changePassword } from "../apis";
import { useTranslation } from 'react-i18next';

function PasswordPage({ apiStatus , onUpdate , form , pwd, setPwd}) {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);

  const rulesCheck = {
    length: pwd.length >= 8,
    upper: /[A-Z]/.test(pwd),
    number: /\d/.test(pwd),
    special: /[^A-Za-z0-9]/.test(pwd),
  };



  const Rule = ({ ok, text }) => (
    <div className={`password-rule ${ok ? 'password-rule--valid' : 'password-rule--invalid'}`}>
      {ok ? (
        <CheckCircleTwoTone twoToneColor="#52c41a" />
      ) : (
        <CloseCircleTwoTone twoToneColor="#d9d9d9" />
      )}
      <span>{text}</span>
    </div>
  );

  return (
    <Form
      form={form}
      layout="vertical"
      style={{ width: "100%" }}
    >
      {apiStatus && (
        <Row style={{ marginBottom: 12 }}>
          <Col span={24}>
            <Alert
              type={apiStatus.type}
              message={
                apiStatus.type === "success" ? t('settings.password.operationSuccess') : t('settings.password.error')
              }
              description={apiStatus.message}
              showIcon
            />
          </Col>
        </Row>
      )}

      <Row gutter={24}>
        <Col xs={24} md={24}>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="currentPassword"
                label={t('settings.password.current')}
                rules={[
                  { required: true, message: t('settings.password.enterCurrent') },
                ]}
              >
                <Input.Password
                  className="setting-input"
                  placeholder={t('settings.password.current')}
                  autoComplete="current-password"
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="newPassword"
                label={t('settings.password.new')}
                rules={[
                  { required: true, message: t('settings.password.enterNew') },
                ]}
              >
                <Input.Password
                  className="setting-input"
                  placeholder={t('settings.password.new')}
                  autoComplete="new-password"
                  onChange={(e) => setPwd(e.target.value)}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="confirmPassword"
                label={t('settings.password.confirm')}
                dependencies={["newPassword"]}
                rules={[
                  { required: true, message: t('settings.password.confirmNew') },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("newPassword") === value)
                        return Promise.resolve();
                      return Promise.reject(
                        new Error(t('settings.password.noMatch'))
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  className="setting-input"
                  placeholder={t('settings.password.confirm')}
                  autoComplete="new-password"
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <div className="password-suggestions">
            <div className="password-suggestions-title">
              {t('settings.password.suggestions')}
            </div>
            <div className="password-rules-container">
              <Rule ok={rulesCheck.length} text={t('settings.password.minLength')} />
              <Rule ok={rulesCheck.upper} text={t('settings.password.uppercase')} />
              <Rule ok={rulesCheck.number} text={t('settings.password.number')} />
              <Rule ok={rulesCheck.special} text={t('settings.password.special')} />
            </div>
          </div>
        </Col>
      </Row>
    </Form>
  );
}

export default PasswordPage;
